import {
  State,
  TransformsPlugin,
  RenderPlugin,
  TweenPlugin,
  minimalLight,
} from '@multiplekex/shallot';
import { OrbitPlugin, LinesPlugin, TextPlugin } from '@multiplekex/shallot/extras';
import {
  createStepPlugin,
  setupCanvas,
  setupScrollPassthrough,
  setupDemo,
} from '@blog-components/sequence';
import { ProbabilityDistributionPlugin, ProbabilityDistribution, setDistributionProbabilities } from '../src';

const STEPS = [
  { title: 'Compare Distributions', description: 'The <span class="term-draft-model">draft</span> and <span class="term-target-model">target</span> models produce different probability distributions.' },
  { title: 'Guaranteed Acceptance', description: 'The <span style="color: #14b8a6">minimum</span> of the two distributions represents probability mass that will always be accepted.' },
  { title: 'Excess Draft', description: 'Where <span class="term-draft-model">draft</span> exceeds <span class="term-target-model">target</span>, tokens may be <span class="term-reject">rejected</span> with probability proportional to the excess.' },
  { title: 'Rejection & Resampling', description: 'When rejected, we <span class="term-residual">resample</span> from the residual—the probability mass where <span class="term-target-model">target</span> exceeds <span class="term-draft-model">draft</span>.' },
  { title: 'Exact Target Distribution', description: 'The <span style="color: #14b8a6">guaranteed acceptance</span> plus <span class="term-residual">residual resampling</span> recovers the exact <span class="term-target-model">target</span> distribution.' },
];

const BAR_COUNT = 10;

const targetProbs = [0.05, 0.12, 0.08, 0.35, 0.15, 0.08, 0.05, 0.04, 0.05, 0.03];
const draftProbs =  [0.08, 0.10, 0.15, 0.20, 0.12, 0.10, 0.08, 0.07, 0.06, 0.04];

async function init(): Promise<void> {
  const canvas = document.getElementById('canvas') as HTMLCanvasElement;
  if (!canvas) return;

  setupCanvas(canvas);
  setupScrollPassthrough(canvas);
  window.addEventListener('resize', () => setupCanvas(canvas));

  const state = await State.new()
    .withCanvas(canvas)
    .withLoading(minimalLight(canvas))
    .withPlugins(
      TransformsPlugin,
      RenderPlugin,
      OrbitPlugin,
      LinesPlugin,
      TextPlugin,
      TweenPlugin,
      createStepPlugin(),
      ProbabilityDistributionPlugin
    )
    .withScene('../scenes/distribution.scene')
    .build();

  const probBarsEids = [...state.query([ProbabilityDistribution])];
  const probBarsEid = probBarsEids[0];

  if (probBarsEid !== undefined) {
    ProbabilityDistribution.barCount[probBarsEid] = BAR_COUNT;
    setDistributionProbabilities(probBarsEid, targetProbs, draftProbs);
  }

  setupDemo(canvas, state, STEPS);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
